<template>
  <div class="dialog-wechat-account-editor-wrapper">
    <el-dialog
      width="50%"
      :title="`添加微信公众号（${user.username}）`"
      :visible="visible"
      :close-on-click-modal="false"
      @open="onDialogOpen"
      @close="onDialogClose">
      <el-form ref="form" :rules="formRule" :model="formData">

        <el-form-item label="公众号名称" prop="accountName">
          <el-input
            placeholder="请输入公众号名称"
            v-model="formData.accountName" />
        </el-form-item>

        <el-form-item label="原始 ID" prop="originalId">
          <el-input
            placeholder="请输入原始 ID"
            v-model="formData.originalId" />
        </el-form-item>

        <el-form-item label="公众号 APP ID" prop="appId">
          <el-input
            placeholder="请输入公众号 APP ID"
            v-model="formData.appId" />
        </el-form-item>

        <el-form-item label="公众号 APP 秘钥" prop="appSecret">
          <el-input
            placeholder="请输入公众号 APP 秘钥"
            v-model="formData.appSecret" />
        </el-form-item>

        <el-form-item label="开发者设置的 Token" prop="token">
          <el-input
            placeholder="请输入开发者设置的 Token"
            v-model="formData.token" />
        </el-form-item>

        <el-form-item label="开发者设置的 EncodingAesKey" prop="encodingAesKey">
          <el-input
            placeholder="请输入开发者设置的 EncodingAesKey"
            v-model="formData.encodingAesKey" />
        </el-form-item>

        <el-form-item label="域名" prop="domain">
          <el-button
            size="mini"
            @click="formData.domain.push('')">添加域名</el-button>
        </el-form-item>
        <div class="domain-list">
          <div class="domain-item"
               v-for="(domain, index) in formData.domain"
               :key="`domain-${index}`">
            <label>域名 {{ index + 1 }}</label>
            <el-input
              class="input"
              placeholder="请输入域名"
              v-model="formData.domain[index]" />
            <el-button
              size="mini"
              @click="onDomainDeleteClick(index)">删除</el-button>
          </div>
        </div>

        <el-form-item label="离线提醒模板" prop="offlineTpl">
          <el-input
            placeholder="请输入离线提醒模板"
            v-model="formData.offlineTpl" />
        </el-form-item>

        <el-form-item label="退款提醒模板" prop="refundTpl">
          <el-input
            placeholder="请输入退款提醒模板"
            v-model="formData.refundTpl" />
        </el-form-item>

        <el-form-item label="设备异常提醒模板" prop="abnormalTpl">
          <el-input
            placeholder="设备异常提醒模板"
            v-model="formData.abnormalTpl" />
        </el-form-item>

        <el-form-item label="库存不足提醒模板" prop="stockTpl">
          <el-input
            placeholder="请输入库存不足提醒模板"
            v-model="formData.stockTpl" />
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 3 }"
            placeholder="请输入备注"
            v-model="formData.remarks" />
        </el-form-item>

      </el-form>

      <div class="submit-box">
        <el-button
          type="danger"
          @click="onFormSubmit">确定</el-button>
        <el-button @click="onFormCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import wechatAccountApi from '@/api/wechatAccountApi'

export default {
  name: 'DialogWechatAccountEditor',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    wechatAccount: {
      type: Object,
      required: false
    },
    mode: {
      type: String,
      required: false,
      default: 'create'
    }
  },
  data () {
    return {
      formData: {
        userId: '',
        accountName: '',
        originalId: '',
        appId: '',
        appSecret: '',
        token: '',
        encodingAesKey: '',
        domain: [
          ''
        ],
        offlineTpl: '',
        refundTpl: '',
        abnormalTpl: '',
        stockTpl: '',
        remarks: ''
      },
      formRule: {
        accountName: [
          { required: true, message: '请输入公众号名称', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入公众号 APP ID', trigger: 'blur' },
          { min: 16, max: 32, message: '公众号 ID 长度必须为 16 位', trigger: 'blur' }
        ],
        appSecret: [
          { required: true, message: '请输入公众号 APP 秘钥', trigger: 'blur' }
        ],
        token: [
          { required: true, message: '请输入开发者设置的 token', trigger: 'blur' }
        ],
        encodingAesKey: [
          { required: true, message: '请输入公众号 EncodingAesKey', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async onDialogOpen () {
      if (this.mode === 'update') {
        this.formData = {
          userId: this.user.userid,
          accountName: this.wechatAccount.accountName,
          originalId: this.wechatAccount.originalId,
          appId: this.wechatAccount.appId,
          appSecret: this.wechatAccount.appSecret,
          token: this.wechatAccount.token,
          encodingAesKey: this.wechatAccount.encodingAesKey,
          domain: this.wechatAccount.domain,
          offlineTpl: this.wechatAccount.offlineTpl,
          refundTpl: this.wechatAccount.refundTpl,
          abnormalTpl: this.wechatAccount.abnormalTpl,
          stockTpl: this.wechatAccount.stockTpl,
          remarks: this.wechatAccount.remarks
        }
      } else {
        this.formData = {
          userId: this.user.userid,
          accountName: '',
          originalId: '',
          appId: '',
          appSecret: '',
          token: '',
          encodingAesKey: '',
          domain: [
            ''
          ],
          offlineTpl: '',
          refundTpl: '',
          abnormalTpl: '',
          stockTpl: '',
          remarks: ''
        }
      }
    },
    onDialogClose () {
      this.$emit('change', false)
      this.$refs['form'].resetFields()
    },

    onDomainDeleteClick (index) {
      if (this.formData.domain.length <= 1) {
        this.$message({
          message: '至少保留一个域名',
          type: 'error'
        })
        return
      }
      this.formData.domain.splice(index, 1)
    },
    async onFormSubmit () {
      try {
        await this.$refs['form'].validate()
        this.$emit('submit', this.formData)
      } catch (err) {
        console.log(err)
      }
    },
    onFormCancel () {
      this.onDialogClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wechat-account-editor-wrapper {

  .domain-list {

    .domain-item {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;

      .input {
        margin: 0 20px;
        width: 70%;
      }
    }
  }

  .submit-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/user/components/DialogWechatAccountEditor.vue